import { defineComponent as P, inject as n, ref as E, computed as G, onMounted as S, onUpdated as x, createElementBlock as T, openBlock as t, Fragment as k, createBlock as r, createCommentVNode as v, normalizeProps as U, mergeProps as h, withCtx as s, renderSlot as m, Teleport as A, unref as C, renderList as V, createTextVNode as j, toDisplayString as w } from "vue";
import z from "../Label/LabelGroup.vue2.js";
import D from "../Label/Label.vue2.js";
import $ from "./ToolbarItem.vue2.js";
import { ToolbarExpandedKey as F, ToolbarUpdateNumberFiltersKey as M, ToolbarLabelGroupContentRefKey as O } from "./Toolbar.vue2.js";
import { ToolbarContentLabelContainerRefKey as _ } from "./ToolbarContent.vue2.js";
import { useOUIAProps as q } from "../../helpers/ouia.js";
import { provideChildrenTracker as H } from "../../use/children-tracker.js";
import { LabelKey as J } from "../Label/common.js";
const le = /* @__PURE__ */ P({
  name: "PfToolbarFilter",
  inheritAttrs: !1,
  __name: "ToolbarFilter",
  props: {
    labels: { default: () => [] },
    category: {},
    hideToolbarItem: { type: Boolean },
    labelGroupExpandedText: {},
    labelGroupCollapsedText: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  emits: ["delete-label", "delete-label-group"],
  setup(K, { emit: L }) {
    const o = K, B = q({ id: o.ouiaId, safe: o.ouiaSafe }), f = L, i = n(F), l = n(M), p = n(_), u = n(O), c = E(!1), d = H(J), y = G(() => i != null && i.value ? p == null ? void 0 : p.value : u == null ? void 0 : u.value);
    S(() => {
      o.category && (l == null || l(o.category, d.length || o.labels.length)), c.value = !0;
    }), x(() => {
      o.category && (l == null || l(o.category, d.length || o.labels.length));
    });
    function g(e) {
      return typeof e == "string" ? e : e.key;
    }
    function I(e) {
      return typeof e == "string" ? e : e.label;
    }
    return (e, b) => (t(), T(k, null, [
      e.hideToolbarItem ? v("", !0) : (t(), r($, U(h({ key: 0 }, e.$attrs)), {
        default: s(() => [
          m(e.$slots, "default")
        ]),
        _: 3
      }, 16)),
      c.value && y.value ? (t(), r(A, {
        key: 1,
        to: y.value
      }, [
        C(d).length || e.labels.length ? (t(), r($, h({ key: 0 }, C(B), { variant: "label-group" }), {
          default: s(() => [
            (t(), r(z, {
              key: e.category,
              category: e.category,
              closable: "",
              "collapsed-text": e.labelGroupCollapsedText,
              "expanded-text": e.labelGroupExpandedText,
              onClick: b[0] || (b[0] = (a) => f("delete-label-group", e.category))
            }, {
              default: s(() => [
                m(e.$slots, "labels", {}, () => [
                  (t(!0), T(k, null, V(e.labels, (a) => (t(), r(D, {
                    key: g(a),
                    variant: "outline",
                    onClick: (N) => f("delete-label", e.category, g(a))
                  }, {
                    default: s(() => [
                      j(w(I(a)), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))), 128))
                ])
              ]),
              _: 3
            }, 8, ["category", "collapsed-text", "expanded-text"]))
          ]),
          _: 3
        }, 16)) : m(e.$slots, "labels", { key: 1 })
      ], 8, ["to"])) : v("", !0)
    ], 64));
  }
});
export {
  le as default
};
